export enum HttpMethod {

    Get = 'GET',
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE',
    Head = 'HEAD',
    Options = 'OPTIONS',
    Patch = 'PATCH'

}
